const selector = '.wp-block-gallery';
const innerSelector = '.blocks-gallery-grid';

function checkHeights() {
  $(selector).each(function() {
    const $block = $(this);
    const $inner = $block.find(innerSelector);
    if ($block.outerHeight() < $inner.outerHeight()) {
      insertShowMoreButton($block, $inner);
    } else {
      $block.find('.wp-block-gallery__show-more').remove();
    }
  });
}

function insertShowMoreButton($block, $inner) {
  if ($block.find('.wp-block-gallery__show-more').length) {
    return;
  }
  const $btnEl = $('<button class="wp-block-gallery__show-more"><span>Visa fler bilder</span></button>');
  $btnEl.on('click', function(e) {
    e.preventDefault();
    showMore($block, $inner, $btnEl);
  });
  $block.append($btnEl);
}

function showMore($block, $inner, $btnEl) {
  $btnEl.remove();
  $block.css('maxHeight', `${ $inner.outerHeight() }px`);
}

export default function() {
  checkHeights();
  $(window).on('resize', checkHeights);
  $(window).on('fpgmedia:post_loaded', checkHeights);
}



// WEBPACK FOOTER //
// ./scripts/components/gallery.js